export default __webpack_public_path__ + "static/media/direction-arrow-right-up.39335798.svg";